import service from '@/script/fetch'

import { bridge, getAppVersion } from '@/script/util';

import * as compareVersions from 'compare-versions';

const path = {
  // 获取游戏开关
  CDP_GetGameStatus: 'CDP_GetGameStatus',
  // 获取竞猜状态
  CDP_GetPredictionStatus: 'CDP_GetPredictionStatus',
  // 获取我的竞猜
  CDP_GetMyCurrentBet: 'CDP_GetMyCurrentBet',
  // 下注
  CDP_BetIncrease: 'CDP_BetIncrease',
  // 获取当前币种跌幅
  CDP_GetCurrentIncrease: 'APP_GetCurrentIncrease',
  // 获取最后一次下注和开奖结果
  CDP_GetMyLastBet: 'CDP_GetMyLastBet',
  // 抽奖
  CDP_TakePrize: 'CDP_TakePrize'
}

function serviceOrBridge(method, params = {}) {
  if (process.env.VUE_APP_IS_LOCAL) {
    return service('&method=' + method + '&request_json=' + JSON.stringify(params).replace(/"/g, ''));
  } else {
    return bridge(method, params);
  }
}

export function CDP_GetGameStatus(params) {
  return serviceOrBridge(path.CDP_GetGameStatus, params);
}

export function CDP_GetPredictionStatus(params) {
  return serviceOrBridge(path.CDP_GetPredictionStatus, params);
}

export function CDP_GetMyCurrentBet(params) {
  return serviceOrBridge(path.CDP_GetMyCurrentBet, params);
}

export function CDP_BetIncrease(params) {
  return serviceOrBridge(path.CDP_BetIncrease, params);
}

export function CDP_GetCurrentIncrease(params) {
  if (!getAppVersion() || compareVersions(getAppVersion(), '2.14.0') < 0) {
    return serviceOrBridge('CDP_GetCurrentIncrease', params);
  } else {
    return serviceOrBridge(path.CDP_GetCurrentIncrease, params);
  }
}

export function CDP_GetMyLastBet(params) {
  return serviceOrBridge(path.CDP_GetMyLastBet, params);
}

export function CDP_TakePrize(params) {
  return serviceOrBridge(path.CDP_TakePrize, params);
}

export function h5_recordEvent(params) {
  return serviceOrBridge('h5_recordEvent', params);
}